// React Lazily
import { lazily } from 'react-lazily'

// Interface
import { IRoute } from 'routes/route.interface'

// Constant
import { PERSONAL_DATA_URL, PERSONAL_DATA_MODULE } from 'constant/url.constant'
import { LAYOUT } from 'constant/layout.constant'

// UI
const { MyDocumentIndex } = lazily(() => import('pages/back-office/personal-data/my-document-corcomm'))

const myDocumentRoutes: IRoute[] = [
  {
    path: PERSONAL_DATA_URL.MY_DOCUMENT,
    component: MyDocumentIndex,
    layout: LAYOUT.BACK_OFFICE,
    exact: true,
    meta: {
      module: PERSONAL_DATA_MODULE,
      requireAuth: true,
      attrs: {
        label: 'backOffice.myDocument',
        accessCodes: [223],
      },
    },
  },
]

export { myDocumentRoutes }